import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';

export async function fetchTags(_, authHeaders) {
    const response = await fetchAndParse(`${API_URL}/s/tags`, {
        method: 'GET',
        headers: { ...jsonHeaders, ...authHeaders }
    });
    return response.results;
}
